<!--
 * @Author: your name
 * @Date: 2021-11-24 16:25:30
 * @LastEditTime: 2022-01-25 16:53:22
 * @LastEditors: Please set LastEditors
 * @Description: 首页 媒体 nav
 * @FilePath: \new-website-1123\src\views\Home\media\nav.vue
-->
<template>
  <ul class="media-nav">
    <li
      v-for="item in navList"
      :key="'media-' + item.id"
      :class="{
        'media-active': item.id == active,
      }"
      class="shou"
      @click="$emit('change', item.id)"
    >
      <span class="title-span">{{ item.label }}</span>
      <span class="time-span">{{ item.time }}</span>
      <div class="more-div">
        <router-link to="/news/details">
          <span class="col-g">
            查看详情
            <img src="@/assets/images/common/jr.png" alt="" />
          </span>
        </router-link>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: "media-nav",
  props: {
    navList: {
      type: Array,
      required: true,
    },
    active: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.media-nav {
  border-left: 1px solid rgba($color: #fff, $alpha: 0.05);
  li {
    display: flex;
    flex-direction: column;
    height: 180px;
    color: rgba($color: #fff, $alpha: 0.4);
    position: relative;
    padding-left: 30px;
    transition: all 0.3s;
    margin-bottom: 10px;
    &.media-active {
      &::before {
        height: 54%;
      }
      .title-span {
        font-family: PingFang SC;
        font-weight: 600;
        color: #ffffff;
      }
      .time-span {
        color: #fff;
      }
      .more-div {
        opacity: 1;
        font-size: 18px;
        img {
          transition: all 0.3s;
        }
        &:hover {
          img {
            transform: translateX(5px);
          }
        }
      }
    }
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 1px;
      height: 0;
      background-color: $color-active;
      transition: all 0.3s;
    }
    .title-span {
      font-size: 30px;
      font-family: PingFang SC;
      font-weight: 600;
      transition: all 0.3s;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
    .time-span {
      color: rgba($color: #fff, $alpha: 0.2);
      margin-top: 16px;
      transition: all 0.3s;
    }
    .more-div {
      opacity: 0;
      // margin-top: 16px;

      & > span {
        display: inline-flex;
        align-items: center;
        img {
          width: 40px;
          margin-left: 10px;
          transition: all 0.3s;
        }
        &:hover {
          img {
            transform: translateX(5px);
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1600px) {
  .media-nav {
    li {
      height: 180px;
      .title-span {
        font-size: 30px;
      }
      .time-span {
        margin-top: 16px;
        margin-bottom: 20px;
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .media-nav {
    li {
      height: 150px;
      .title-span {
        font-size: 24px;
      }
      .time-span {
        margin-top: 14px;
        margin-bottom: 18px;
      }
    }
  }
}
@media screen and (max-height: 850px) {
  .media-nav {
    li {
      height: 120px;
      .title-span {
        font-size: 18px;
      }
      .time-span {
        margin-top: 8px;
        margin-bottom: 10px;
      }
    }
  }
}
</style>
